// src/components/ChatbotButton.jsx
import React from "react";

function ChatbotButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="fixed bottom-6 right-6 p-4 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 text-white shadow-lg hover:shadow-xl hover:scale-105 transition-transform duration-300 z-40 focus:outline-none focus:ring-4 focus:ring-blue-300"
      aria-label="Open Chatbot"
    >
      {/* Custom SVG Chatbot Icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-6 h-6"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M12 2a9 9 0 00-9 9c0 1.7.47 3.28 1.28 4.64L3 21l5.73-1.91A9 9 0 1012 2zm-3 8a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2z" />
      </svg>
    </button>
  );
}

export default ChatbotButton;
